export const projects = [
  {
    id: 1,
    title: "مطلوب مسوق إلكتروني محترف",
    username: "محمدشريف د.",
    time: "منذ 5 ساعات",
    offersNumber: "11 عرض",
    description: `مرحبا

مطلوب مسوق إلكتروني محترف ومتمكن ، للعمل على التسويق وإدارة الحملات الإعلانية لمنصة بيع خدمات التصميم كتصميم المتاجر والمواقع، خدمات تصميم صفحات السوشل ميديا ، إضافة المنتجات وغيرها من الخدمات

المطلوب :

1 مسوق قادر على تحديد الجمهور المستهدف بدقة وتحديد المنصات الإعلانية المناسبة

2 محترف في كتابة النصوص الإعلانية المقنعة

3 إطلاق ومتابعة الحملات الإعلانية على

غوغل

فيسبوك وإنستغرام

سناب شات

4 تحقيق مبيعات وجلب عملاء

مهم : العمل سيكون مستمر وبشكل شهري اذا كانت النتائج جيدة

شرط أن يتم تحقيق مبيعات دون استنزاف الميزانية التسويقية`,
  },

  {
    id: 2,
    title: "لوحة تحكم لمتجر اونلاين وإنشاء api",
    username: "Mohamed R.",
    time: "منذ 5 ساعات",
    offersNumber: "7 عروض",
    description: `يوجد تطبيق لبيع المنتجات أونلاين ، وله لوحة تحكم ولكن بها أخطاء ونريد لوحة أخرى غيرها .

    اللوحة تتضمن :
    
    - إضافة منتجات .
    
    - إضافة تصنيفات .
    
    فقط لا غير`,
  },

  {
    id: 3,
    title: "مطلوب توثيق حسابات السوشيال ميديا - جهة حكومية",
    username: "Ibrahim B.",
    time: "منذ 6 ساعات",
    offersNumber: "4 عروض",
    description: `مطلوب العمل على توثيق حسابات السوشيال ميديا لجهة حكومية على المنصات التالية :

    سناب شات
    
    إنستقرام
    
    فيسبوك
    
    تويتر - علامة التوثيق الفضية
    
    لينكدإن
    
    من لديه الخبرة في توثيق حسابات السوشيال ميديا نأمل التواصل`,
  },

  {
    id: 4,
    title: "تصميم هويات ومؤثرات بصرية",
    username: "Hussam M.",
    time: "منذ 6 ساعات",
    offersNumber: "25 عرض",
    description: `السلام عليكم ورحمة الله وبركاته

    نحن وكالة حلول تسويقية مقرنا المملكة العربية السعودية
    
    نحتاج للتعاقد مع مصمم ذو خبرة وروح إبداعية من يجد في نفسه الكفاءة يرجى التواصل معي على الخاص
    
    وضح بعرضك حجم العمل الذي تقدمه مقابل قيمة عرضك`,
  },

  {
    id: 5,
    title: "إنشاء موقع بسيط",
    username: "Mohammed M.",
    time: "منذ 6 ساعات",
    offersNumber: "26 عرض",
    description: "أريد إنشاء موقع من صفحة واحدة أتمكن بربطه ببوابة دفع",
  },

  {
    id: 6,
    title: "تكويد تصميم UI/UX إلى HTML",
    username: "عثمان ع.",
    time: "منذ 6 ساعات",
    offersNumber: "33 عرض",
    description: `مرحباً،

    لدي تصميم figma ، أريد تكويده ل html ويكون متوافق مع كل المتصفحات والموبايل، التصميم جاهز سوف يتم إرساله للمستقل
    
    أريد تكويده بدون أخطاء ، وأيضا إضافة أنيميشن وحركات للتصميم
    
    يجب أن يكون المستقل لديه أعمال سابقة`,
  },

  {
    id: 7,
    title: "تثبيت قالب اوبن كارد",
    username: "Azal E.",
    time: "منذ 6 ساعات",
    offersNumber: "4 عروض",
    description:
      "عندي استضافة على بلوهوست ومتجر جديد أوبن كارد وعندي الثيم جاهز من منصة themeforest وأريد شخص يثبت الثيم على المنصة",
  },

  {
    id: 8,
    title: "مدقق حسابات عمل عن بعد",
    username: "اثير ا.",
    time: "منذ 6 ساعات",
    offersNumber: "21 عرض",
    description: `السلام عليكم ورحمة الله وبركاته

    ابحث عن مدقق حسابات يعمل عن بعد بدوام جزئي
    
    متطلبات العمل:
    
    الحصول على درجة البكالوريوس في المحاسبة أو المالية.
    
    خبرة سابقة في وظيفة مدقق أو مراجع حسابات أو مجال المحاسبة
    
    الاطلاع والمعرفة بالقوانين واللوائح المحاسبية.
    
    التعامل مع البرامج المحاسبة
    
    الوصف الوظيفي:
    
    مراجعة وتدقيق الوضع المالي والبيانات المالية في الشركة
    
    تدقيق الأمور المالية والقيود المحاسبية
    
    إعداد قوائم الدخل
    
    إعداد الميزانيات
    
    جمع المعلومات المالية المتعلقة بالشركة وتدقيقها والتحقق من سلامة الوضع المالي للشركة وخلوه من أي أخطاء مالية أو عدم وجود نصب واحتيال
    
    تقييم التقارير المالية والحسابات`,
  },

  {
    id: 9,
    title: "مطلوب مدرسين إعدادي وثانوي لشرح منهج سعودي",
    username: "Hadeer M.",
    time: "منذ 6 ساعات",
    offersNumber: "32 عرض",
    description: `محتاجين مدرسين في المواد التالية جيولوجيا كيمياء حاسب إلى إعدادي وثانوي رياضيات إعدادي وثانوي إنجليزي الشرح عند بعد عن طريق برنامج ميكروسوفت وايت بورد فيديوهات مسجلة خاصة لينا غير مكرره`,
  },

  {
    id: 10,
    title: "مساعدة بنشر بحث في المجال الطبي في مجلة علمية بأسرع وقت",
    username: "Professor C.",
    time: "منذ 6 ساعات",
    offersNumber: "5 عروض",
    description: `أقوم بعمل بحث علمي في المجال الطبي واحتاج لذو خبرة للتمكن من نشره في مجلة علمية طبية في أسرع وقت من لديه خبرة في نشر الأبحاث العلمية للمساعدة بعمل بحث علمي في المجال الطبي للتمكن من نشره في مجلة علمية طبية في أسرع وقت`,
  },

  {
    id: 11,
    title: "تسجيل كرت ابل بي لمغسلة مع إضافة اكسل",
    username: " راكان ا.",
    time: "منذ 6 ساعات",
    offersNumber: "عرض واحد",
    description: `السلام عليكم ورحمة الله وبركاته أحتاج شخص يسوي كرت آبل بي لمشروع مغسلة .

    النموذج مثل مغسلة shift tik
    
    المطلوب نسوي نموذج قوقل فورم وبيانات العملاء اللي تسجل في هذا النموذج تتجمع في الإكسل . ويكون لكل موظف يوزر نيم وباسورد لتسجيل أي زبون من طرف الموظف . ( داشبورد بسيط ل اكسل qr code`,
  },

  {
    id: 12,
    title: "تخطيط هندسي إنشائي لمطعم",
    username: "سالم ب.",
    time: "منذ 6 ساعات",
    offersNumber: "17 عرض",
    description: "تخطيط هندسي لمطعم 200 متر مربع",
  },
];
